import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress } from '@getgo/chameleon-web-react-wrapper';
import classNames from 'classnames';
import classes from './index.module.scss';
const Loading = ({ className, opaque = false }) => {
    return (_jsx("div", Object.assign({ className: classNames(classes.loading, opaque && classes.opaque, className) }, { children: _jsx(CircularProgress, {}, void 0) }), void 0));
};
export default Loading;
//# sourceMappingURL=index.js.map